// import React from 'react';

// const Footer = () => (
//   <footer className="bg-blue-800 text-white text-center p-6 mt-10">
//     <p>&copy; {new Date().getFullYear()} Systematic Career Planner. All Rights Reserved.</p>
//   </footer>
// );

// export default Footer;
// import React from "react";
// import ParticleBackground from "./ParticleBackground";

// export default function Footer() {
//   return (
//     // <footer id="contact" className="relative overflow-hidden bg-brand-400 text-white mt-8">
//     //   <div className="absolute inset-0 opacity-40">
//     //     <ParticleBackground />
//     //   </div>

//     //   <div className="relative mx-auto max-w-7xl px-4 py-12">
//     //     <div className="grid md:grid-cols-3 gap-6">
//     //       <div>
//     //         <h4 className="text-lg font-semibold mb-2">Systematic Career Planner</h4>
//     //         <p className="text-white/90 text-sm max-w-sm">
//     //           Empowering students & professionals with structured guidance, skill‑building, and mentor‑led growth.
//     //         </p>
//     //       </div>
//     //       <div>
//     //         <h4 className="text-lg font-semibold mb-2">Quick Links</h4>
//     //         <ul className="space-y-2 text-sm text-white/90">
//     //           <li><a className="hover:underline" href="#services">Services</a></li>
//     //           <li><a className="hover:underline" href="#about">About</a></li>
//     //           <li><a className="hover:underline" href="#contact">Contact</a></li>
//     //         </ul>
//     //       </div>
//     //       <div>
//     //         <h4 className="text-lg font-semibold mb-2">Get in touch</h4>
//     //         <p className="text-white/90 text-sm">contact@systematiccareerplanner.com</p>
//     //         <p className="text-white/90 text-sm">+91 00000 00000</p>
//     //       </div>
//     //     </div>

//     //     <div className="mt-8 border-t border-white/20 pt-4 text-sm text-white/80">
//     //       © {new Date().getFullYear()} Systematic Career Planner. All rights reserved.
//     //     </div>
//     //   </div>
//     // </footer>
//     <footer className="relative bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white  rounded-t-2xl shadow-2xl">
//       <div className="absolute inset-0 opacity-40">
//          <ParticleBackground />
//       </div>
//       <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]"></div>

//       <div className="max-w-7xl mx-auto px-6 py-12 relative z-10 grid md:grid-cols-3 gap-8 text-center md:text-left">
//         <div>
//           <h3 className="text-xl font-bold mb-3">Systematic Career Planner</h3>
//           <p className="text-sm opacity-90">
//             Empowering students & professionals with structured guidance, skill-building, and mentor-led growth.
//           </p>
//         </div>

//         <div>
//           <h3 className="text-xl font-bold mb-3">Quick Links</h3>
//           <ul className="space-y-2">
//             <li><a href="#services" className="hover:font-semibold transition">Services</a></li>
//             <li><a href="#about" className="hover:font-semibold transition">About</a></li>
//             <li><a href="#contact" className="hover:font-semibold transition">Contact</a></li>
//           </ul>
//         </div>

//         <div>
//           <h3 className="text-xl font-bold mb-3">Get in Touch</h3>
//           <p className="text-sm">📧 contact@systematiccareerplanner.com</p>
//           <p className="text-sm">📞 +91 00000 00000</p>
//         </div>
//       </div>

//       <div className="text-center py-4 border-t border-white/30 text-sm opacity-90 relative z-10">
//         © {new Date().getFullYear()} Systematic Career Planner. All rights reserved.
//       </div>
//     </footer>
//   );
// }
// import React from "react";
// import ParticleBackground from "./ParticleBackground";
// import { Facebook, Twitter, Linkedin, Instagram, Youtube } from "lucide-react";

// export default function Footer() {
//   return (
//     <footer className="relative bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white rounded-t-2xl shadow-2xl">
//       {/* Background Effects */}
//       <div className="absolute inset-0 opacity-40">
//         <ParticleBackground />
//       </div>
//       <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]"></div>

//       {/* Main Footer Content */}
//       <div className="max-w-7xl mx-auto px-6 py-14 relative z-10 grid md:grid-cols-4 gap-10 text-center md:text-left">
        
//         {/* Brand */}
//         <div>
//           <h3 className="text-2xl font-extrabold mb-2">
//             Systematic Career Planner
//           </h3>
//           <p className="text-sm opacity-90 leading-relaxed">
//             Empowering students & professionals with structured guidance,
//             skill-building, and mentor-led growth.
//           </p>
//           <p className="mt-3 text-xs italic opacity-80">
//             “Your roadmap to success, one step at a time.”
//           </p>
//         </div>

//         {/* Quick Links */}
//         <div>
//           <h3 className="text-xl font-bold mb-3">Quick Links</h3>
//           <ul className="space-y-2">
//             <li><a href="#services" className="hover:underline hover:font-semibold transition">Services</a></li>
//             <li><a href="#about" className="hover:underline hover:font-semibold transition">About</a></li>
//             <li><a href="#contact" className="hover:underline hover:font-semibold transition">Contact</a></li>
//             <li><a href="#faq" className="hover:underline hover:font-semibold transition">FAQs</a></li>
//             <li><a href="#careers" className="hover:underline hover:font-semibold transition">Careers</a></li>
//           </ul>
//         </div>

//         {/* Resources */}
//         <div>
//           <h3 className="text-xl font-bold mb-3">Resources</h3>
//           <ul className="space-y-2">
//             <li><a href="#blog" className="hover:underline hover:font-semibold transition">Blog</a></li>
//             <li><a href="#guides" className="hover:underline hover:font-semibold transition">Guides</a></li>
//             <li><a href="#privacy" className="hover:underline hover:font-semibold transition">Privacy Policy</a></li>
//             <li><a href="#terms" className="hover:underline hover:font-semibold transition">Terms & Conditions</a></li>
//             <li><a href="#support" className="hover:underline hover:font-semibold transition">Support</a></li>
//           </ul>
//         </div>

//         {/* Newsletter & Social */}
//         <div>
//           <h3 className="text-xl font-bold mb-3">Stay Updated</h3>
//           <p className="text-sm opacity-90 mb-3">
//             Subscribe to get the latest career tips, resources & updates.
//           </p>
//           <div className="flex items-center bg-white/20 rounded-xl overflow-hidden">
//             <input
//               type="email"
//               placeholder="Enter your email"
//               className="flex-1 px-3 py-2 text-black placeholder-gray-600 outline-none"
//             />
//             <button className="bg-yellow-400 text-black px-4 py-2 font-semibold hover:bg-yellow-300 transition">
//               Subscribe
//             </button>
//           </div>

//           {/* Social Icons */}
//           <div className="mt-5">
//             <p className="text-sm mb-2 font-semibold">Follow Us</p>
//             <div className="flex justify-center md:justify-start space-x-4">
//               <a href="#" className="hover:text-yellow-300 transition"><Facebook size={20} /></a>
//               <a href="#" className="hover:text-yellow-300 transition"><Twitter size={20} /></a>
//               <a href="#" className="hover:text-yellow-300 transition"><Linkedin size={20} /></a>
//               <a href="#" className="hover:text-yellow-300 transition"><Instagram size={20} /></a>
//               <a href="#" className="hover:text-yellow-300 transition"><Youtube size={20} /></a>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Bar */}
//       <div className="text-center py-4 border-t border-white/30 text-sm opacity-90 relative z-10">
//         © {new Date().getFullYear()}{" "}
//         <span className="font-semibold">Systematic Career Planner</span>. All
//         rights reserved. | Crafted with ❤️ for career dreamers
//       </div>
//     </footer>
//   );
// }
// import React, { useState } from "react";
// import ParticleBackground from "./ParticleBackground";
// import { Facebook, Twitter, Linkedin, Instagram, Youtube } from "lucide-react";

// export default function Footer({ onSupportClick }) {  // ✅ accept chatbot open prop
//   const [email, setEmail] = useState(""); 
//   const [status, setStatus] = useState(""); 
//   const handleSubscribe = async () => { if (!email || !/\S+@\S+\.\S+/.test(email)) { setStatus("❌ Please enter a valid email"); 
//     return; } 
//   try { const res = await fetch("http://localhost:5000/subscribe", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email }), }); 
//   const data = await res.json(); if (res.ok) { setStatus("✅ Subscription successful!"); setEmail(""); } 
//   else { setStatus("⚠️ " + data.error); } } 
//   catch (err) { setStatus("⚠️ Server error, try again later."); } };
//   return (
//     <footer className="relative bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white rounded-t-2xl shadow-2xl">
//       {/* Background Effects */}
//       <div className="absolute inset-0 opacity-40">
//         <ParticleBackground />
//       </div>
//       <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]"></div>

//       {/* Main Footer Content */}
//       <div className="max-w-7xl mx-auto px-6 py-14 relative z-10 grid gap-10 md:grid-cols-4 text-center md:text-left">
        
//         {/* Brand */}
//         <div className="flex flex-col items-center md:items-start">
//           <h3 className="text-2xl font-extrabold mb-2">
//             Systematic Career Planner
//           </h3>
//           <p className="text-sm opacity-90 leading-relaxed max-w-xs">
//             Empowering students & professionals with structured guidance,
//             skill-building, and mentor-led growth.
//           </p>
//           <p className="mt-3 text-xs italic opacity-80">
//             “Your roadmap to success, one step at a time.”
//           </p>
//         </div>

//         {/* Quick Links */}
//         <div className="mx-auto">
//           <h3 className="text-xl font-bold mb-3 justify-center">Quick Links</h3>
//           <ul className="space-y-2">
//             <li><a href="#services" className="hover:underline transition">Services</a></li>
//             <li><a href="#about" className="hover:underline transition">About</a></li>
//             <li><a href="#contact" className="hover:underline transition">Contact</a></li>
//             <li><a href="#roadmap" className="hover:underline transition">Roadmap</a></li>
//             <li><a href="#" className="hover:underline transition">FAQs</a></li>
//             <li><a href="#" className="hover:underline transition">Careers</a></li>
//           </ul>
//         </div>

//         {/* Resources */}
//         <div>
//           <h3 className="text-xl font-bold mb-3">Resources</h3>
//           <ul className="space-y-2">
//             <li><a href="#" className="hover:underline transition">Blog</a></li>
//             <li><a href="#" className="hover:underline transition">Guides</a></li>
//             <li><a href="#" className="hover:underline transition">Privacy Policy</a></li>
//             <li><a href="#" className="hover:underline transition">Terms & Conditions</a></li>
//             <li>
//               {/* ✅ Support opens Chatbot */}
//               <button
//                 onClick={onSupportClick}
//                 className="hover:underline transition"
//               >
//                 Support
//               </button>
//             </li>
//           </ul>
//         </div>

//         {/* Newsletter & Social */}
//         <div className="flex flex-col items-center md:items-start">
//           <h3 className="text-xl font-bold mb-3">Stay Updated</h3>
//           <p className="text-sm opacity-90 mb-3 max-w-xs">
//             Subscribe to get the latest career tips, resources & updates.
//           </p>

//           {/* Newsletter Input */}
//           <div className="flex w-full max-w-sm rounded-xl overflow-hidden border border-white/30">
//             <input
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="flex-1 px-3 py-2 text-black placeholder-gray-600 outline-none"
//             />
//             <button onClick={handleSubscribe} className="bg-yellow-400 text-black px-4 py-2 font-semibold hover:bg-yellow-300 transition">
//               Subscribe
//             </button>
//           </div>
//             {status && <p className="mt-2 text-sm">{status}</p>}

//           {/* Social Icons */}
//           <div className="mt-5 w-full">
//             <p className="text-sm mb-2 font-semibold">Follow Us</p>
//             <div className="flex justify-center md:justify-start space-x-4">
//               <a href="#" className="hover:text-yellow-300 transition"><Facebook size={20} /></a>
//               <a href="#" className="hover:text-yellow-300 transition"><Twitter size={20} /></a>
//               <a href="#" className="hover:text-yellow-300 transition"><Linkedin size={20} /></a>
//               <a href="#" className="hover:text-yellow-300 transition"><Instagram size={20} /></a>
//               <a href="#" className="hover:text-yellow-300 transition"><Youtube size={20} /></a>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Bar */}
//       <div className="text-center py-4 border-t border-white/30 text-sm opacity-90 relative z-10">
//         © {new Date().getFullYear()}{" "}
//         <span className="font-semibold">Systematic Career Planner</span>. All
//         rights reserved. | Crafted with ❤️ for career dreamers
//       </div>
//     </footer>
//   );
// }
import React, { useState } from "react";
import ParticleBackground from "./ParticleBackground";
import { Facebook, Twitter, Linkedin, Instagram, Youtube } from "lucide-react";

// Use localhost PHP server during development, and relative path in production (Hostinger)
const API_URL = process.env.NODE_ENV === 'production' ? '/contact.php' : 'http://localhost:8000/contact.php';

export default function Footer({ onSupportClick, onStartRoadmap, onQuickLinkClick }) {  // added roadmap click handler
  const [email, setEmail] = useState(""); 
  const [status, setStatus] = useState(""); 

    // const handleSubscribe = async () => {
    //   if (!email || !/\S+@\S+\.\S+/.test(email)) {
    //     setStatus("❌ Please enter a valid email");
    //     return;
    //   }
    //   // old local dev example preserved here for reference
    // };

    const handleSubscribe = async () => {
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setStatus("❌ Please enter a valid email");
      return;
    }
    setStatus("⏳ Subscribing...");
    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'subscribe',
          email: email,
        }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setStatus("✅ Subscription successful! Check your inbox ✉️");
        setEmail("");
      } else {
        setStatus("⚠️ " + (data.error || "Something went wrong. Try again."));
      }
    } catch (err) {
      setStatus("⚠️ Network error, try again later.");
    }

    // Previous Web3Forms subscription logic (commented out for reference):
    // const res = await fetch("https://api.web3forms.com/submit", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify({
    //     access_key: "8249345c-8a2e-416b-aa16-4d2805a793d9",
    //     subject: "New User for Systematic Career Planner Subscription",
    //     from_name: "Systematic Career Planner Newsletter",
    //     email: email,
    //     message: `Systematic Career Planner Newsletter subscriber : ${email}`,
    //     botcheck: "",
    //   }),
    // });
    // const data = await res.json();
    // if (data.success) {
    //   setStatus("✅ Subscription successful! Check your inbox ✉️");
    //   setEmail("");
    // } else {
    //   setStatus("⚠️ Something went wrong. Try again." + data.error);
    // }
  };

  // scroll to section if exists, else trigger fallback
  const scrollToSection = (id, fallback) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else if (fallback) {
      fallback();
    }
  };

  return (
    <footer className="relative bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white rounded-t-2xl shadow-2xl">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-40">
        <ParticleBackground />
      </div>
      <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]"></div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-14 relative z-10 grid gap-10 md:grid-cols-4 text-center md:text-left">

        {/* Brand */}
        <div className="flex flex-col items-center md:items-start">
          <h3 className="text-2xl font-extrabold mb-2">Systematic Career Planner</h3>
          <p className="text-sm opacity-90 leading-relaxed max-w-xs">
            Structured career planning at every stage — from school to professional growth. Invest time. Build career. Secure future.
          </p>
          <p className="text-sm opacity-90 mt-2">📞 <a href="tel:+919920405421" className="hover:underline">+91 9920405421</a></p>
          <p className="text-sm opacity-90 mt-1">📧 <a href="mailto:connect@systematiccareerplanner.com" className="hover:underline">connect@systematiccareerplanner.com</a></p>
          <p className="mt-3 text-xs italic opacity-80">"Plan Your Career Like You Plan Your Investments."</p>
        </div>

        {/* Quick Links */}
        <div className="mx-auto">
          <h3 className="text-xl font-bold mb-3 justify-center">Quick Links</h3>
          <ul className="space-y-2">
            <li><button onClick={() => scrollToSection("services")} className="hover:underline transition">Services</button></li>
            <li><button onClick={() => scrollToSection("about")} className="hover:underline transition">About</button></li>
            <li><button onClick={() => scrollToSection("contact")} className="hover:underline transition">Contact</button></li>
            <li>
              <button 
                onClick={() => scrollToSection("roadmap", onStartRoadmap)} 
                className="hover:underline transition"
              >
                Roadmap
              </button>
            </li>
            {/* <li><button onClick={() => scrollToSection("faqs")} className="hover:underline transition">FAQs</button></li>
            <li><button onClick={() => scrollToSection("careers")} className="hover:underline transition">Careers</button></li> */}
            <li><button onClick={() => scrollToSection("why")} className="hover:underline transition">Why Choose Us</button></li>
            <li><button onClick={() => scrollToSection("process")} className="hover:underline transition">Career Journey</button></li>
            <li><button onClick={() => onQuickLinkClick("faqs")} className="hover:underline">FAQs</button></li>
            <li><button onClick={() => onQuickLinkClick("careers")} className="hover:underline">Careers</button></li>
          </ul>
        </div>

        {/* Resources */}
        <div>
          <h3 className="text-xl font-bold mb-3">Resources</h3>
          <ul className="space-y-2">
            {/* <li><button onClick={() => scrollToSection("blog")} className="hover:underline transition">Blog</button></li>
            <li><button onClick={() => scrollToSection("guides")} className="hover:underline transition">Guides</button></li>
            <li><button onClick={() => scrollToSection("privacy")} className="hover:underline transition">Privacy Policy</button></li>
            <li><button onClick={() => scrollToSection("terms")} className="hover:underline transition">Terms & Conditions</button></li> */}
            {/* <ul className="space-y-2"> */}
            <li><button onClick={() => onQuickLinkClick("blog")} className="hover:underline">Blog</button></li>
            <li><button onClick={() => onQuickLinkClick("guides")} className="hover:underline">Guides</button></li>
            <li>
              <button onClick={onSupportClick} className="hover:underline transition">Support</button>
            </li>
            <li><button onClick={() => scrollToSection("testimonials")} className="hover:underline transition">Testimonials</button></li>
            <li><a href="https://wa.me/919920405421?text=Hello!%20I'm%20interested%20in%20career%20guidance." target="_blank" rel="noopener noreferrer" className="hover:underline transition">WhatsApp Us</a></li>
            <li><button onClick={() => onQuickLinkClick("privacy")} className="hover:underline">Privacy Policy</button></li>
            <li><button onClick={() => scrollToSection("contact")} className="hover:underline transition">Book Consultation</button></li>
            <li><button onClick={() => onQuickLinkClick("terms")} className="hover:underline">Terms & Conditions</button></li>
          {/* </ul> */}
          </ul>
        </div>

        {/* Newsletter & Social */}
        <div className="flex flex-col items-center md:items-start">
          <h3 className="text-xl font-bold mb-3">Stay Updated</h3>
          <p className="text-sm opacity-90 mb-3 max-w-xs">
            Subscribe to get the latest career tips, resources & updates.
          </p>

          {/* Newsletter Input */}
          <div className="flex flex-col gap-2 sm:flex-row w-full max-w-sm rounded-xl overflow-hidden border border-white/30">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 min-w-0 px-3 py-2 text-sm sm:text-base text-black placeholder-gray-600 outline-none"
            />
            <button 
              onClick={handleSubscribe} 
              className="w-full sm:w-auto bg-yellow-400 text-black px-4 py-2 text-sm sm:text-base font-semibold hover:bg-yellow-300 transition whitespace-nowrap shrink-0"
            >
              Subscribe
            </button>
          </div>

          {status && <p className="mt-2 text-sm">{status}</p>}

          {/* Social Icons */}
          <div className="mt-5 w-full">
            <p className="text-sm mb-2 font-semibold">Follow Us</p>
            <div className="flex justify-center md:justify-start space-x-4">
              <button className="hover:text-yellow-300 transition"><Facebook size={20} /></button>
              <button className="hover:text-yellow-300 transition"><Twitter size={20} /></button>
              <button className="hover:text-yellow-300 transition"><Linkedin size={20} /></button>
              <button className="hover:text-yellow-300 transition"><Instagram size={20} /></button>
              <button className="hover:text-yellow-300 transition"><Youtube size={20} /></button>
            </div>
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="text-center py-4 border-t border-white/30 text-sm opacity-90 relative z-10">
        © {new Date().getFullYear()} <span className="font-semibold">Systematic Career Planner</span>. All rights reserved. | Crafted with ❤️ for career dreamers
      </div>
    </footer>
  );
}
